import { ChangeEvent, useCallback, useState } from 'react';

import { useDebounce } from '@mint-lib/hooks';

import { useAiHubPermissions } from './useAiHubPermissions.jsx';

export const useChatSidebarState = () => {
  const { canScheduleChat } = useAiHubPermissions();
  const [selectedChatType, setSelectedChatType] = useState<
    'live' | 'scheduled' | 'all'
  >(canScheduleChat ? 'all' : 'live');

  const [searchValue, setSearchValue] = useState('');
  const debouncedSearchValue = useDebounce(searchValue, 1000);

  const handleChangeSearch = useCallback(({ target }: ChangeEvent) => {
    setSearchValue((target as HTMLInputElement).value);
  }, []);

  const handleClearSearch = useCallback(() => setSearchValue(''), []);

  return {
    selectedChatType,
    setSelectedChatType,
    searchValue,
    debouncedSearchValue,
    handleChangeSearch,
    handleClearSearch,
  };
};
